import React from 'react';
import {RoutePermittedRole} from '../../../shared/constants/AppEnums';
import EditProductAttributes from './product-attributes/edit-product-attributes';
import MangeSubColorProductAttributes from './product-attributes/edit-product-attributes/mange-sub-color';
import CreateSpecificationAttributes from './specification-attributes/create-specification-attributes';

const ProductAttributes = React.lazy(() => import('./product-attributes'));
const SpecificationAttributes = React.lazy(
  () => import('./specification-attributes'),
);

export const catalogAttributesConfig = [
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/catalog.attributes/product-attributes',
    element: <ProductAttributes />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/catalog.attributes/specification-attributes',
    element: <SpecificationAttributes />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/catalog.attributes/specification-attributes/create-specification-attributes',
    element: <CreateSpecificationAttributes />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/catalog.attributes/specification-attributes/edit-specification-attributes/:id',
    element: <CreateSpecificationAttributes />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/catalog.attributes/product-attributes/edit-product-attribute/:id',
    element: <EditProductAttributes />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/catalog.attributes/product-attributes/mange-subColor/:id',
    element: <MangeSubColorProductAttributes />,
  },
];
